import { useCallback } from "react"
import { useAnalytics } from "connected-components/analytics"
import type { ModuleConfig } from "../modules/types"
import type { ModuleType } from "../modules/types"
import { trackDashboardModuleAdded } from "./track-module-added"

export function useTrackDashboardModuleAdded() {
  const analytics = useAnalytics()

  return useCallback(
    (moduleType: ModuleType, config: ModuleConfig) => {
      trackDashboardModuleAdded(analytics, moduleType, config)
    },
    [analytics],
  )
}
